export default { sha: '67b27f039aaed57dc43ca36490e6b3738e2401a3', buildNumber: 'undefined' }
